import { Texture } from "@pixi/core";
import { NewsResourcePackage } from "../../../resources/NewsResourcePackage";
import { NewsCardView } from "./NewsCardView";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { Container, Point } from "pixi.js";
import { VisitNewsCard } from "../../../flow/impl/news/VisitNewsCard";
import { IPlayerModel } from "by/gamefactory/cityversetycoon/scenes/common/models/IPlayerModel";
import { PromiseCompletionSource } from "by/gamefactory/shared/async/PromiseCompletionSource";
import { AnimationTargetProvider } from "by/gamefactory/cityversetycoon/scenes/common/components/AnimationTargetProvider";
import { FlyToTargetAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/animations/FlyToTargetAnimation";
import { CoinsTexturePack } from "by/gamefactory/cityversetycoon/scenes/common/components/animations/texturesPacks/CoinsTexturePack";
import { UserProfileResourcePackage } from "by/gamefactory/cityversetycoon/scenes/popups/userprofile/resources/UserProfileResourcePackage";

export class VisitNewsCardView extends NewsCardView {
    private commonResources: CommonResourcesPackage;
    private playerModel: IPlayerModel;
    private newsCard: VisitNewsCard;
    private animationTargetProvider: AnimationTargetProvider;

    public constructor(
        canvasScaler: ICanvasScaler,
        newsResourcesPackage: NewsResourcePackage,
        commonResources: CommonResourcesPackage,
        userProfileResources: UserProfileResourcePackage,
        guestAvatar: Texture,
        newsCard: VisitNewsCard,
        playerModel: IPlayerModel,
        animationTargetProvider: AnimationTargetProvider
    ) {
        super(
            newsResourcesPackage.assets_views_news_visit_background_png,
            userProfileResources,
            guestAvatar,
            newsCard.guest.firstName.toUpperCase(),
            "VISITED YOU",
            canvasScaler
        );
        this.commonResources = commonResources;
        this.playerModel = playerModel;
        this.newsCard = newsCard;
        this.animationTargetProvider = animationTargetProvider;
    }

    protected layoutData(): void {
        this.avatar.position.set(394, 92);
        this.guestNameText.position.set(
            496,
            100
        );
        this.messageText.position.set(
            428,
            178
        );
    }

    public accrueResult(waitForComplete: PromiseCompletionSource<void>): void {
        const coinsTextures = new CoinsTexturePack(this.commonResources).randomCoins;
        const animationContainer = new Container();
        this.parent.addChild(animationContainer);
        const animation = new FlyToTargetAnimation(
            animationContainer,
            coinsTextures,
            {
                from: new Point(0, 120),
                target: new Point(800, 120),//this.animationTargetProvider.resolve(this.newsCard.constructor.name).position as Point,
                particlesAmount: 20,
                duration: 1.5
            }

        );
        this.playerModel.addCoins(this.newsCard.rewardInCoins);
        animation.play().then(() => {
            this.parent.removeChild(animationContainer);
            waitForComplete.complete();
        });
    }
}
